import axios from "axios";

//Sign User from Sign in page
export const signUpUserEntry = async (values) => {
    var result = { Status: true, Message: "", Data: null };
    //let UserImages = values.photos.map((img) => img.indexOf("static/") === -1 ? img.split('base64,')[1] : img);
    let data = {
        LoginId: values.loginId,
        Password: values.confirmPassword,
        DisplayName: values.displayName,
        Email: values.email,
        PhoneNb: values.loginId,
        Active: null,
    }
    try {
        const response = await axios.post(`/api/SignUp/CreateCompanyUser`, data);
        if (response && response.status === 200) {
            return response.data;
        } else {
            result.Status = false;
            result.Message = "Something went wrong";
            return result;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        } else {
            result.Status = false;
            result.Message = "Unhandled exception";
            return result;
        }
    }
}

export const signupvarifyphone = async (phNo) => {
    var result = { Status: true, Message: "", Data: null };
    try {
        const response = await axios.post(`/api/Common/smsverification`, { phoneNo: phNo });
        if (response && response.status === 200) {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        } else {
            result.Status = false;
            result.Message = "Unhandled exception";
            return result;
        }
    }
}

export const duplicatedUser = async (id) => {
    var result = { Status: true, Message: "", Data: null };
    var data = {
        loginid: id
    }
    try {
        const response = await axios.post(`/api/Common/DuplicatedUser`, data);
        if (response && response.status === 200) {
            return response;
        } else {
            return response.status
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        } else {
            result.Status = false;
            result.Message = "Unhandled exception";
            return result;
        }
    }
}